import { useSelector } from "react-redux"
import {Doughnot} from "../charts"
export default function({filtered}) {
    const mainOverview = useSelector((state) => state.accountOverview)
    const filteredOverview = mainOverview.filteredOverview
    const overview = !filtered ? mainOverview : filteredOverview
    let { 
        numberOfProjects, 
        totalScans, 
        vulnerabilitiesAddressed, 
        vulnerabilitiesIdentified
    } = overview
    
    return <div className="flex flex-col h-fit min-w-[300px]">
        <div className="flex items-center justify-end mb-2 w-full ">
            <div className="px-8 py-4 bg-slate-50 shadow-md rounded-md flex flex-col flex-grow items-center mr-2">
                <h1 className="text-sm font-thin">Total Projects</h1>
                <h1 className="text-4xl font-semibold">{numberOfProjects}</h1>
            </div>
            <div className="px-8 py-4 bg-slate-50 shadow-md rounded-md flex flex-col items-center flex-grow">
                <h1 className="text-sm font-thin">Total Scans</h1>
                <h1 className="text-4xl font-semibold">{totalScans}</h1>
            </div>
        </div>
        <div className="flex items-center w-full">
            <div className="flex flex-col items-center w-full bg-slate-50 shadow-md rounded-md py-9">
                <div className="flex items-center text-slate-500">
                    <div className="mr-2">
                        <h1 className="font-semibold text-md self-start mb-2">Vulnerabilities</h1>

                        <div className="flex items-center ml-2">
                            <span className="w-1 h-5 rounded-md bg-red-200 mr-2"></span>
                            <h1>{vulnerabilitiesIdentified - vulnerabilitiesAddressed} Identified</h1>
                        </div>
                        <div className="flex items-center ml-2">
                            <span className="w-1 h-5 rounded-md bg-green-200 mr-2"></span>
                            <h1>{vulnerabilitiesAddressed} Addressed</h1>
                        </div>
                    </div>
                    <div className="w-40 vulns-chart flex justify-center items-center relative top-0 bottom-0 left-0 right-0">
                        <Doughnot vulns={vulnerabilitiesIdentified} vulnsAddressed={vulnerabilitiesAddressed}></Doughnot>
                        <div className="vulns-count absolute">
                            <h1 className="text-3xl font-bold">{vulnerabilitiesIdentified}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}